import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=eff8c7b0"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eff8c7b0')) {
      api.createRecord('eff8c7b0', component.options)
    } else {
      api.reload('eff8c7b0', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=eff8c7b0", function () {
      api.rerender('eff8c7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-avatar/UserAvatar.vue"
export default component.exports